import * as React from 'react';
import ForgotLinkPageView from '../layouts/ForgotPasswordLinkView';
import { Snackbar } from '@material-ui/core';
import { AlertTitle } from '@material-ui/lab';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';

function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export interface ForgotLinkPageProps {
    onComponentDidMount: () => void;
    onSubmit: () => void;
    btnElement: string;
    btnType: string;
    saveUsername: (username: string) => void;
    errorMessage: string;
    errorBar: boolean;
    successMessage: string;
    successBar: boolean;
    handleClose: () => void;
    userName: string;
}

class ForgotLinkPage extends React.Component<ForgotLinkPageProps> {
    render() {
        return (
            <div>
                <ForgotLinkPageView
                    saveUsername={this.props.saveUsername}
                    onSubmit={this.props.onSubmit}
                    userName={this.props.userName}
                />
                <Snackbar
                    open={this.props.errorBar}
                    autoHideDuration={2000}
                    onClose={this.props.handleClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Alert
                        severity="error"
                    >
                        <AlertTitle>Error</AlertTitle>
                        {this.props.errorMessage}
                    </Alert>
                </Snackbar>
                <Snackbar
                    open={this.props.successBar}
                    autoHideDuration={2000}
                    onClose={this.props.handleClose}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <Alert
                        severity="success"
                    >
                        <AlertTitle>Success</AlertTitle>
                        {this.props.successMessage}
                    </Alert>
                </Snackbar>
            </div>
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
    }
}

export default ForgotLinkPage;



// WEBPACK FOOTER //
// ./src/components/forgotPasswordLinkPage/ForgotLinkPage.tsx